import { LabelValue } from '../interfaces/interfaces';

export const countriesObject: {[key: string]: string} = {
    AF: 'Afganisztán',
    AL: 'Albánia',
    DZ: 'Algéria',
    US: 'Amerikai Egyesült Államok',
    AD: 'Andorra',
    AO: 'Angola',
    AG: 'Antigua és Barbuda',
    AR: 'Argentína',
    AU: 'Ausztrália',
    AT: 'Ausztria',
    AZ: 'Azerbajdzsán',
    BS: 'Bahama-szigetek',
    BH: 'Bahrein',
    BD: 'Banglades',
    BB: 'Barbados',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BT: 'Bhután',
    GW: 'Bissau-Guinea',
    BO: 'Bolívia',
    BA: 'Bosznia-Hercegovina',
    BW: 'Botswana',
    BR: 'Brazília',
    BN: 'Brunei',
    BG: 'Bulgária',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CL: 'Chile',
    CY: 'Ciprus',
    KM: 'Comore-szigetek',
    CR: 'Costa Rica',
    TD: 'Csád',
    CZ: 'Csehország',
    DK: 'Dánia',
    ZA: 'Dél-afrikai Köztársaság',
    SS: 'Dél-Szudán',
    KR: 'Dél-Korea (Koreai Köztársaság)',
    DM: 'Dominikai Közösség',
    DO: 'Dominikai Köztársaság',
    DJ: 'Dzsibuti',
    EC: 'Ecuador',
    GQ: 'Egyenlítői-Guinea',
    AE: 'Egyesült Arab Emírségek',
    GB: 'Egyesült Királyság',
    EG: 'Egyiptom',
    CI: 'Elefántcsontpart',
    SV: 'Salvador',
    ER: 'Eritrea',
    KP: 'Észak-Korea (Koreai NDK)',
    EE: 'Észtország',
    ET: 'Etiópia',
    BY: 'Fehéroroszország',
    FJ: 'Fidzsi',
    FI: 'Finnország',
    FR: 'Franciaország',
    PH: 'Fülöp-szigetek',
    GA: 'Gabon',
    GM: 'Gambia',
    GH: 'Ghána',
    GR: 'Görögország',
    GD: 'Grenada',
    GE: 'Grúzia',
    GT: 'Guatemala',
    GN: 'Guinea',
    GY: 'Guyana',
    HT: 'Haiti',
    NL: 'Hollandia',
    HN: 'Honduras',
    HR: 'Horvátország',
    IN: 'India',
    ID: 'Indonézia',
    IQ: 'Irak',
    IR: 'Irán',
    IE: 'Írország',
    IS: 'Izland',
    IL: 'Izrael',
    JM: 'Jamaica',
    JP: 'Japán',
    YE: 'Jemen',
    JO: 'Jordánia',
    KH: 'Kambodzsa',
    CM: 'Kamerun',
    CA: 'Kanada',
    QA: 'Katar',
    KZ: 'Kazahsztán',
    TL: 'Kelet-Timor',
    KE: 'Kenya',
    CN: 'Kína',
    KG: 'Kirgizisztán',
    KI: 'Kiribati',
    CO: 'Kolumbia',
    CD: 'Kongói Demokratikus Köztársaság (Zaire)',
    CG: 'Kongói Köztársaság (Kongó)',
    CF: 'Közép-Afrika',
    CU: 'Kuba',
    KW: 'Kuvait',
    LA: 'Laosz',
    PL: 'Lengyelország',
    LS: 'Lesotho',
    LV: 'Lettország',
    LB: 'Libanon',
    LR: 'Libéria',
    LY: 'Líbia',
    LI: 'Liechtenstein',
    LT: 'Litvánia',
    LU: 'Luxemburg',
    MK: 'Észak-Macedónia',
    MG: 'Madagaszkár',
    HU: 'Magyarország',
    MY: 'Malajzia',
    MW: 'Malawi',
    MV: 'Maldív-szigetek',
    ML: 'Mali',
    MT: 'Málta',
    MA: 'Marokkó',
    MH: 'Marshall-szigetek',
    MR: 'Mauritánia',
    MU: 'Mauritius',
    MX: 'Mexikó',
    MM: 'Mianmar',
    FM: 'Mikronézia',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongólia',
    ME: 'Montenegró',
    MZ: 'Mozambik',
    NA: 'Namíbia',
    NR: 'Nauru',
    DE: 'Németország',
    NP: 'Nepál',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigéria',
    NO: 'Norvégia',
    IT: 'Olaszország',
    OM: 'Omán',
    RU: 'Oroszország',
    AM: 'Örményország',
    PK: 'Pakisztán',
    PW: 'Palau',
    PA: 'Panama',
    PG: 'Pápua Új-Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PT: 'Portugália',
    RO: 'Románia',
    RW: 'Ruanda',
    KN: 'Saint Kitts és Nevis',
    LC: 'Saint Lucia',
    VC: 'Saint Vincent és a Grenadine-szigetek',
    SB: 'Salamon-szigetek',
    SM: 'San Marino',
    ST: 'São Tomé és Príncipe',
    SC: 'Seychelle-szigetek',
    SL: 'Sierra Leone',
    ES: 'Spanyolország',
    LK: 'Srí Lanka',
    SR: 'Suriname',
    CH: 'Svájc',
    SE: 'Svédország',
    WS: 'Szamoa',
    SA: 'Szaúd-Arábia',
    SN: 'Szenegál',
    RS: 'Szerbia',
    SG: 'Szingapúr',
    SY: 'Szíria',
    SK: 'Szlovákia',
    SI: 'Szlovénia',
    SO: 'Szomália',
    SD: 'Szudán',
    SZ: 'Szváziföld',
    TJ: 'Tádzsikisztán',
    TZ: 'Tanzánia',
    TH: 'Thaiföld',
    TG: 'Togo',
    TO: 'Tonga',
    TR: 'Törökország',
    TT: 'Trinidad és Tobago',
    TN: 'Tunézia',
    TV: 'Tuvalu',
    TM: 'Türkmenisztán',
    UG: 'Uganda',
    NZ: 'Új-Zéland',
    UA: 'Ukrajna',
    UY: 'Uruguay',
    UZ: 'Üzbegisztán',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnám',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    CV: 'Zöld-foki Köztársaság'
};

export const COUNTRIES_LABELVALUE: LabelValue[] = Object.keys(countriesObject).map((value) => ({
    label: countriesObject[value],
    value
}));
